class DotScroll extends HTMLElement {
  constructor() {
    super();

    const containerSelector = this.dataset.containerSelector;
    if (!containerSelector) throw new Error('dot-scroll-element missing data-container-selector');

    const container = document.querySelector(containerSelector);
    container.addEventListener('scroll', this.onScroll.bind(this));

    this.activeStyle = this.dataset.activeStyle;
    this.inactiveStyle = this.dataset.inactiveStyle;

    this.isVertical = this.dataset.isVertical === 'true';

    for (let i = 0; i < this.children.length; i++) {
      this.children[i].addEventListener('click', () => {
        if (this.isVertical) {
          container.scrollTo({
            top: container.children[i].offsetTop,
            behavior: 'smooth',
          });
        } else {
          container.scrollTo({
            left: container.children[i].offsetLeft,
            behavior: 'smooth',
          });
        }
      });
    }
  }

  onScroll(e) {
    const newIndex = this.isVertical
      ? Math.round(e.currentTarget.scrollTop / (e.currentTarget.scrollHeight / e.currentTarget.children.length)) + 1
      : Math.round(e.currentTarget.scrollLeft / (e.currentTarget.scrollWidth / e.currentTarget.children.length)) + 1;

    for (const child of this.children) {
      child.style = this.inactiveStyle ?? 'background-color:#FFFFFF00;';
    }
    this.children[newIndex - 1].style = this.activeStyle ?? 'background-color:#FFFFFFFF;';
  }
}

customElements.define('dot-scroll-element', DotScroll);
